import { observable } from "mobx";

class Combo {
	@observable hasShowLeadFunnelModal = false;
	staticContext;

	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this.staticContext = staticContext;
	}

	get searchPanelStore() {
		const { searchPanelStore } = this.rootStore.stores;
		return searchPanelStore;
	}

	get proListItemStore() {
		const { proListItemStore } = this.rootStore.stores;
		return proListItemStore;
	}

	get quickPickQuestionStore() {
		const { quickPickQuestionStore } = this.rootStore.stores;
		return quickPickQuestionStore;
	}

	get provider() {
		return this.proListItemStore?.selectedProvider;
	}

	get zipcode() {
		return this.searchPanelStore?.zipcode || this.staticContext?.zipcode;
	}

	get service() {
		if (this.searchPanelStore?.selectedServiceKey) {
			return { key: this.searchPanelStore.selectedServiceKey };
		}
		return this.staticContext?.service || this.staticContext?.midtail;
	}

	get base64EncodedAnswerKeys() {
		return this.quickPickQuestionStore?.encodedSelection;
	}

	get showcasePros() {
		const providers = this.staticContext?.providers || [];
		return providers
			.filter((provider) => provider.reviews.length === 2)
			.slice(0, 8);
	}

	get searchLink() {
		let url = "/search";
		if (this.service?.search_to_map) url = "/search-map";
		return `${url}?service=${this.service.key}&zipcode=${this.zipcode || ""}`;
	}
}

export default Combo;
